export default "__VITE_ASSET__DhQgfuqs__"